import React, { PropsWithChildren } from 'react';
import { Link as GatsbyLink, GatsbyLinkProps } from 'gatsby';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { HEADER_VARIABLES } from './Header';

import { Classname } from 'utils/types';

type TLink = {
  href: string;
  external?: boolean;
} & JSX.IntrinsicElements['a'] &
  Classname;

export const StyledLink = styled.a<Partial<GatsbyLinkProps<Record<string, string>>>>`
  ${({ theme: { durations, tp, mq } }) => css`
    ${tp.useFont(fonts => fonts.Montserrat.lightBold)}

    transition: color ${durations.regular};
    padding: 0 2rem;
    text-decoration: none;
    line-height: 1.22;
    color: var(${HEADER_VARIABLES.textColor});
    font-size: 2.25rem;

    &:active {
      color: var(${HEADER_VARIABLES.textActiveColor});
    }

    ${mq.md} {
      display: flex;
      position: relative;
      align-items: center;
      padding: 2rem;
      width: 100%;
    }
  `}
`;

const Link: React.FC<PropsWithChildren<TLink>> = ({
  children,
  href,
  external = false,
  className,
  ...props
}) => {
  const linkProps = external ? { href, target: '_blank' } : { as: GatsbyLink, to: href };

  return (
    <StyledLink {...linkProps} {...props} className={className}>
      {children}
    </StyledLink>
  );
};

export default Link;
